<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>

    <UPDATE ref="exConfigSetting" @submit="submit" :updateData="configSetting"></UPDATE>

    <el-dialog ref="proposalDialog" :title="$t('crs.bt.proposal')"  :visible.sync="dialogStatus.dialogVisible"  width="30%" :before-close="handleClose">
      <el-select value="" v-model="dialogStatus.statusType" style="margin-top: 10px">
        <el-option value="" v-for="option in dialogStatus.statusData" :label="option.value" :value="option.key"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-input type="textarea" :rows="4" :placeholder="$t('crs.bt.proposal')" maxlength="100" show-word-limit  v-model="dialogStatus.reason"  ></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">{{ $t('crs.bt.close') }}</el-button>
          <el-button type="primary" @click="statusConfirm">{{ $t('crs.bt.confirm') }}</el-button>
       </span>
      </span>
    </el-dialog>


  </div>
</template>

<script>

import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/crs/util/url'
import UPDATE from '@/components/page/update'

let statusArr = { 0: '未審覈', 1: '已通過', 2: '未通過' }

let  managerFactory= {"national":"國際","domestic":"國內"}

export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },
  created() {
  },

  methods: {
    handleClose() {
      console.info("I do");
      this.dialogStatus.reason = ''
      this.dialogStatus.dialogVisible = false
    },
    checkbox(row) {
      this.deleteIds = row.map(key => key.id).join(',')
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      }else if (window.$t('crs.quantityTask.setting') == clickName || '设置' == clickName) {
        this.$axios.get(Url.quantityTask.configGet, {
          params: {
            businessTypeAlias: DateUtil.getParamKey(this.$route.params)
          }
        }).then(res => {
          if (res.code == 0) {
            if (res.result) {
              this.$refs.exConfigSetting.open(res.result)
            } else {
              this.$refs.exConfigSetting.open()
            }
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
       if (clickName == 'proposal') {
        this.dialogStatus.dialogVisible = true
        this.dialogStatus.row = row
      }
    },
    statusConfirm() {
      this.dialogStatus.row.status=this.dialogStatus.statusType
      this.dialogStatus.row.remark=this.dialogStatus.reason
      this.dataChange(Url.quantityTask.exProposalStatus, this.dialogStatus.row, res => {
        if (res.code == 0) {
          this.$refs.proposalDialog.hide();
          this.$refs.childTable.defaultGetData(this.queryData)
          this.$message.success('suc')
        } else {
          this.$message.error(res.message)
        }
      })
    },

    submit(model) {
      this.dataChange(Url.quantityTask.configEdit, model, res => {
        if (res.code == 0) {
          this.$refs.exConfigSetting.close();
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    }

  },
  data() {
    return {
      deleteIds: '',
      dialogStatus: {
        statusData:[{ value: '同意', key: 1 }, { value: '不同意', key: 2 }],
        statusType: 1,
        dialogVisible: false,
        reason: '',
        row: {}
      },

      queryData: {},

      configSetting: {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          { title: window.$t('crs.quantityTask.exrate'), field: 'exrate',required:true },
          { title: window.$t('crs.quantityTask.maxEx'), field: 'maxEx',required:true,isNumber:true },
          { title: window.$t('crs.quantityTask.gmt'), field: 'gmt',required:true,isNumber:true },
          { title: window.$t('crs.quantityTask.gtsManagerFac'), field: 'gtsManagerFac',required:true,type:2,optionList:managerFactory},
          {title: 'businessTypeAlias',field: 'businessTypeAlias',data: DateUtil.getParamKey(this.$route.params),hidden: true}
        ]
      },

      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          {title: 'businessTypeAlias',field: 'businessTypeAlias',data: DateUtil.getParamKey(this.$route.params),hidden: true},
          { title: window.$t('crs.quantityTask.customerNumber'), field: 'customerNumber', isNumber: true },
          { title: window.$t('crs.quantityTask.phone'), field: 'phone'},
          { title: window.$t('crs.quantityTask.startTime'), field: 'startTime', type:5,format: 'yyyy-MM-dd HH:mm:ss'},
          { title: window.$t('crs.quantityTask.endTime'), field: 'endTime',type:5,format: 'yyyy-MM-dd HH:mm:ss'},
          { click: window.$t('common.search')},
          { click: window.$t('crs.quantityTask.setting'), auth: 'crs:taskConfig:setting' }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.quantityTask.exProposalQuery,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: "ID", field: 'id' },
          { title: window.$t('crs.quantityTask.customerNumber'), field: 'customerNumber' },
          { title: window.$t('crs.quantityTask.phone'), field: 'phone' },
          { title: window.$t('crs.quantityTask.userName'), field: 'userName' },
          { title: window.$t('crs.quantityTask.quantity'), field: 'quantity' },
          { title: window.$t('crs.quantityTask.exrate'), field: 'exrate' },
          { title: window.$t('crs.quantityTask.examount'), field: 'examount' },
          {
            title: window.$t('crs.quantityTask.status'), field: 'status', render: (data, full) => {
              return statusArr[data]
            }
          },
          {
            title: window.$t('crs.quantityTask.ctime'), field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: window.$t('crs.quantityTask.uname'), field: 'uname' },
          {
            title: window.$t('crs.quantityTask.utime'), field: 'utime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },

          { title: window.$t('crs.common.remark'), field: 'remark' },
          {
            title: window.$t('crs.bt.operation'),
            btnClick: [
              {
                name: window.$t('crs.bt.proposal'),
                click: 'proposal',
                type: 'primary',
                icon: 'el-icon-add',
                auth: 'crs:quantityTask:exProposal',
                hidden: (model, col) => {
                  return col.status == 0 ? false : true
                }
              }]
          }
        ]
      }
    }
  }
}
</script>
